/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ owner: NonNullable<unknown> }} Team_Manager_SubtitleInputs */



/**
* | output |
* | --- |
* | "Team owned by {owner}" |
*
* @param {Team_Manager_SubtitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_subtitle = /** @type {((inputs: Team_Manager_SubtitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_SubtitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Équipe de ${i?.owner}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Team von ${i?.owner}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Team di ${i?.owner}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Команда владельца ${i?.owner}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Equipo de ${i?.owner}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.owner} 的团队`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.owner} のチーム`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.owner} की टीम`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Equipa de ${i?.owner}`)
	return /** @type {LocalizedString} */ (`Team owned by ${i?.owner}`)
});